var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = !_vm.loadding ? _vm.theme() || "" : null
  var m1 = !_vm.loadding ? _vm.theme() : null
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.isType = true
    }
    _vm.e1 = function ($event) {
      _vm.isType = false
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }